import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=3c5d608a&scoped=true&"
import script from "./Init.vue?vue&type=script&lang=ts&"
export * from "./Init.vue?vue&type=script&lang=ts&"
import style0 from "./Init.vue?vue&type=style&index=0&id=3c5d608a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d608a",
  null
  
)

export default component.exports